import React from "react";
import { useQuery, gql } from "@apollo/client";
import Spinner from "components/Spinner";
import { market_market } from "../types/market";

export const MARKETS_QUERY = gql`
  query markets {
    markets(count: 15) {
      id
      name
      position {
        lat
        lng
      }
      cities {
        id
        name
        position
        state
        neighborhoods {
          id
          name
          yearlyPricePerFoot
        }
      }
    }
  }
`;

type Props = {
  name: string;
  className: string;
  selectedMarket: market_market;
  onMarketChange: (market: market_market) => void;
};

const MarketSelector = ({
  onMarketChange,
  selectedMarket,
  className = "",
  name = "marketsSelect",
}: Props) => {
  const { data, loading } = useQuery(MARKETS_QUERY);
  if (loading) return <Spinner />;
  return (
    <div className={`select ${className}`}>
      <select
        name={name}
        onChange={(e) => {
          onMarketChange(
            data.markets.find(
              (market: market_market) => market.name === e.target.value
            )
          );
        }}
        defaultValue={selectedMarket?.name}
      >
        {data?.markets?.map((market: market_market) => (
          <option key={`market-${market.id}`} value={market.name}>
            {market.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default MarketSelector;
